import {
    CloudUploadOutlined,
    DashboardOutlined,
    ForwardToInboxOutlined,
    Groups,
    HandshakeOutlined,
    LanguageOutlined,
    PublicOutlined,
    TuneOutlined
} from "@mui/icons-material";
import { OrganizationTypesEnum, Page, UserRole } from "@therapprove/common";

const pages: Page[] = [
    {
        label: "Dashboard",
        icon: DashboardOutlined,
        path: "/dashboard"
    },
    {
        label: "Team",
        icon: Groups,
        path: "/team"
    },
    {
        label: "Global Referrals",
        icon: PublicOutlined,
        path: "/global-referrals",
        hideFromOrganizationTypes: [OrganizationTypesEnum.CoordinationCenter],
        hideFromRoles: [UserRole.CASE_MANAGER]
    },
    {
        label: "Referral Pipeline",
        icon: TuneOutlined,
        path: "/referral-pipeline"
    },
    {
        label: "Invites",
        icon: ForwardToInboxOutlined,
        path: "/invites"
    },
    {
        label: "Direct Referrals",
        icon: HandshakeOutlined,
        path: "/direct-referrals",
        indicator: "priorityReferralCount"
    },
    {
        label: "Website Leads",
        icon: LanguageOutlined,
        path: "/website-leads",
        indicator: "websiteLeadCount"
    },
    {
        label: "Files",
        icon: CloudUploadOutlined,
        path: "/files"
    }
];

export default pages;
